import { useContext } from 'react';
import { ClipboardContext, ClipboardContextType } from './ClipboardContext';

// Custom hook to use the clipboard context
export const useClipboard = (): ClipboardContextType => {
  const context = useContext(ClipboardContext);

  if (context === undefined) {
    throw new Error('useRateCardChargesClipboard must be used within a RateCardChargesClipboardProvider');
  }

  return context;
};
